import React from "react";
import {
  withStyles,
  Dialog,
} from "@material-ui/core";
import { withSnackbar } from "notistack";
import ReturnShipmentGrid from "./Grid/index";
import styles from "./styles";
import { compose } from "recompose";
import { getDataWithQueryString } from "../../../../../api/componentAPIs";
import MESSAGES from "../../../../../appMessages";
import Events from "../../../../../utilities/EventEmitter";
import appConstants from "../../../../../appConstants";

class ReturnShipments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      returnShipments: null,
      gridErrorMessage: "loading",
    };
  }

  componentDidMount() {
    Events.on("OpenReturnShipments", this.toggleReturnShipmentsModel);
  }

  componentWillUnmount() {
    Events.off("OpenReturnShipments", this.toggleReturnShipmentsModel);
  }

  fetchReturnShipmentsData = () => {
    if (!this.state.open) {
      return;
    }
    const terminalCode = this.props.userProfile.terminal.code;
    getDataWithQueryString(
      "GetReturnShipments",
      `terminalCode=${terminalCode}`
    ).then((res) => {
      if (res.status === 200) {
        this.setState({
          returnShipments: res.data,
          gridErrorMessage: appConstants.GRID_STATUS.SUCCESS,
        });
      } else {
        this.handleError();
      }
    });
  };

  toggleReturnShipmentsModel = () => {
    this.setState(
      (prevState) => ({
        open: !prevState.open,
      }),
      this.fetchReturnShipmentsData
    );
  };

  handleError = () => {
    this.props.enqueueSnackbar(MESSAGES.COMMON.LOADING_DATA, {
      variant: "error",
    });
    this.setState({
      gridErrorMessage: appConstants.GRID_STATUS.ERROR,
      returnShipments: [],
    });
  };

  render() {
    const { classes } = this.props;
    const { theme } = this.props.userProfile || {};
    const { open, gridErrorMessage } = this.state;
    return (
      <>
        <Dialog
          aria-labelledby="return-shipments"
          open={open}
          classes={{ paper: classes.dialog }}
          className={`${classes.dialogWrapper} ${theme}`}
        >
          <ReturnShipmentGrid
            returnShipments={this.state.returnShipments}
            gridErrorMessage={gridErrorMessage}
            userProfile={this.props.userProfile}
            onCloseModel={this.toggleReturnShipmentsModel}
          />
        </Dialog>
      </>
    );
  }
}

export default compose(withSnackbar, withStyles(styles))(ReturnShipments);
